"use strict";
import { __exports as e } from "./index.es342.js";
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var a;
function u() {
  if (a) return e;
  a = 1;
  var f = Symbol.for("react.transitional.element"), s = Symbol.for("react.fragment");
  function n(y, r, t) {
    var o = null;
    if (t !== void 0 && (o = "" + t), r.key !== void 0 && (o = "" + r.key), "key" in r) {
      t = {};
      for (var i in r)
        i !== "key" && (t[i] = r[i]);
    } else t = r;
    return r = t.ref, {
      $$typeof: f,
      type: y,
      key: o,
      ref: r !== void 0 ? r : null,
      props: t
    };
  }
  return e.Fragment = s, e.jsx = n, e.jsxs = n, e;
}
export {
  u as __require
};
//# sourceMappingURL=index.es250.js.map
